module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/$.redefine.js
// module id = 1156
// module chunks = 0